import { isString } from "es-toolkit";

/** Whether the uploadedFileResponse is of type SingleFileUploadResponse */
export function isSingleFileUploadResponse(uploadedFileResponse) {
  return isString(uploadedFileResponse);
}

/** Whether the MultiFileUploadResponse is of type UploadedFile */
export function isUploadedFile(uploadedFileResponse) {
  return "id" in uploadedFileResponse && typeof uploadedFileResponse.id === "string" && "fileName" in uploadedFileResponse && typeof uploadedFileResponse.fileName === "string" && "fileSize" in uploadedFileResponse && typeof uploadedFileResponse.fileSize === "number" && "fileType" in uploadedFileResponse && typeof uploadedFileResponse.fileType === "string" && "downloadUrl" in uploadedFileResponse && typeof uploadedFileResponse.downloadUrl === "string" && "md5" in uploadedFileResponse && typeof uploadedFileResponse.md5 === "string";
}

/** Whether the MultiFileUploadResponse is of type UploadFailedFile */
export function isUploadFailedFile(uploadedFileResponse) {
  return "id" in uploadedFileResponse && typeof uploadedFileResponse.id === "string" && "fileName" in uploadedFileResponse && typeof uploadedFileResponse.fileName === "string" && "errorMessage" in uploadedFileResponse && typeof uploadedFileResponse.errorMessage === "string";
}

/** Whether the MultiFileUploadResponse is of type CanceledUploadFile */
export function isCanceledUploadFile(uploadedFileResponse) {
  return "id" in uploadedFileResponse && typeof uploadedFileResponse.id === "string" && "fileName" in uploadedFileResponse && typeof uploadedFileResponse.fileName === "string" && !("errorMessage" in uploadedFileResponse) && !("downloadUrl" in uploadedFileResponse);
}